import { FC } from 'react';

import DirectDebitBacsForm from 'components/direct-debit-bacs-form/direct-debit-bacs-form';
import DirectDebitBacsHeader from 'components/direct-debit-bacs-header';
import DirectDebitBecsForm from 'components/direct-debit-becs-form';
import DirectDebitBecsHeader from 'components/direct-debit-becs-header';
import DirectDebitPadForm from 'components/direct-debit-pad-form';
import DirectDebitPadHeader from 'components/direct-debit-pad-header';
import DirectDebitSepaForm from 'components/direct-debit-sepa-form';
import DirectDebitSepaHeader from 'components/direct-debit-sepa-header';
import { useAppSelector } from 'hooks';
import { directDebitType } from 'modules/payment-methods';
import { DD_TYPES } from 'utils/constants';

const DirectDebitAdd: FC = (): JSX.Element => {
  const selectedDirectDebitType = useAppSelector(directDebitType);

  return (
    <>
      {
        {
          [DD_TYPES.sepa]: (
            <>
              <DirectDebitSepaHeader />
              <DirectDebitSepaForm />
            </>
          ),
          [DD_TYPES.bacs]: (
            <>
              <DirectDebitBacsHeader />
              <DirectDebitBacsForm />
            </>
          ),
          [DD_TYPES.becs]: (
            <>
              <DirectDebitBecsHeader />
              <DirectDebitBecsForm />
            </>
          ),
          [DD_TYPES.pad]: (
            <>
              <DirectDebitPadHeader />
              <DirectDebitPadForm />
            </>
          ),
        }[selectedDirectDebitType]
      }
    </>
  );
};

export default DirectDebitAdd;
